// extracted by css-extract-rspack-plugin
export default {"codeFileContents":"CodeLinesSSRNoVirtualization-module__codeFileContents__BHJ0j","viewRemainderLink":"CodeLinesSSRNoVirtualization-module__viewRemainderLink__AfKEx"};